import type { RetargetingCandidate } from './retargeting.types';

export function findDuplicateIndex(
  candidates: RetargetingCandidate[],
  next: Pick<RetargetingCandidate, 'useCase' | 'displayName' | 'targetUrl'>
): number {
  return candidates.findIndex(
    existing =>
      existing.useCase === next.useCase &&
      existing.displayName === next.displayName &&
      existing.targetUrl === next.targetUrl
  );
}
